<template>
  <div>
    <a href="tel:+33158012970">Phone : +33 (0) 1.58.01.29.70</a>
    <Loader v-if="isDataLoading"/>
    <div v-else>
      <Table
        :title="$t('views.support.title')"
        :addLabel="$t('views.support.add')"
        :headers="ticketsHeaders"
        :rows="ticketsRows"
        :values="tickets"
        :addPermission="openningGeneralTicketPermission"
        @add="openTicket"
        @export="exportTickets"/>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import SUPPORT from '@/api/support';

import Loader from '@/components/Loader.vue';

import { eventHubMixin } from '@/mixins/event';


export default {
  name: 'support',
  mixins: [eventHubMixin],
  components: {
    Table: () => import('@/components/Table'),
    Loader,
  },
  data() {
    return {
      isDataLoading: true,
      tickets: null,
      ticketsHeaders: [
        {
          label: this.$t('views.support.config.ticketsHeaders.number'),
          field: 'ticket_number',
        },
        {
          label: this.$t('views.support.config.ticketsHeaders.title'),
          field: 'title',
        },
        {
          label: this.$t('views.support.config.ticketsHeaders.age'),
          field: 'age',
        },
        {
          label: this.$t('views.support.config.ticketsHeaders.from'),
          field: 'article[0].from_email_format',
        },
        {
          label: this.$t('views.support.config.ticketsHeaders.state'),
          field: 'state',
        },
      ],
      ticketsRows: [
        {
          value: row => row.ticket_number,
          classList: 'badge',
          link: row => ({
            href: row.url,
            alt: 'Ticket OTRS',
            target: '_blank',
          }),
          color: row => 'gray-700',
        },
        {
          value: row => row.title,
          link: row => ({
            href: row.url,
            alt: 'Ticket OTRS',
            target: '_blank',
          }),
        },
        {
          value: row => row.age,
          link: row => ({
            href: row.url,
            alt: 'Ticket OTRS',
            target: '_blank',
          }),
        },
        {
          value: row => row.article[0].from_email_format,
          link: row => ({
            href: `mailto:${row.article[0].from_email_format}`,
          }),
          color: row => 'gray-700',
        },
        {
          value: row => row.state.toUpperCase(),
          link: row => ({
            href: row.url,
            alt: 'Ticket OTRS',
            target: '_blank',
          }),
          classList: 'is-xsmall',
        },
      ],
    }
  },

  computed: {
    ...mapGetters({
      user: 'auth/user',
    }),
  
    openningGeneralTicketPermission() {
      if (this.user.is_admin || this.user.roles_obj.some(role => role.opening_general_ticket)) {
        return true
      }
      return false
    },
  },

  created() {
    this.listTickets();
  },

  methods: {
    listTickets() {
      SUPPORT.list('limit=25').then(
        (res) => {
          if (res.data && res.data.hasOwnProperty('tickets')) {
            this.tickets = res.data.tickets;
          } else {
            this.tickets = [];
          }
          this.isDataLoading = false;
        },
      );
    },

    openTicket() {
      this.emitOpenModal('open-ticket');
    },

    exportTickets() {
      SUPPORT.export();
    },
  },
};
</script>
